import { render, staticRenderFns } from "./SignPopover.vue?vue&type=template&id=7daa77d6&"
import script from "./SignPopover.vue?vue&type=script&lang=js&"
export * from "./SignPopover.vue?vue&type=script&lang=js&"
import style0 from "./SignPopover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports